import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
export default {
  title: 'Image',
  attributeName: 'videoPoster',
  getURL: '',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  itemType:'videoPoster',
  type:FormInputTypes.DOWNLOADABLE,
  sessionParams: [],
};
